import { makeStyles } from "@material-ui/core"
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { useState } from "react"
import RateGraph from "src/components/widgets/RateGraph"
import SavingsGraph from "src/components/widgets/SavingsGraph"
import UsageGraph from "src/components/widgets/UsageGraph"
import { graph1, graph2, graph3 } from "src/mock/graph"


export default () => {
    const classes = useStyles();
    const [graph, setGraph] = useState("1");

    const ShowGraph = () => {
        switch (graph) {
            case "1":
                return <RateGraph
                    dataKey="kwh"
                    data={graph1}
                    width={666}
                    height={336}
                />;
            case "2":
                return <SavingsGraph
                    dataKey="name"
                    data={graph2}
                    width={666}
                    height={336}
                />;
            case "3":
                return <UsageGraph
                    dataKey="name"
                    data={graph3}
                    width={666}
                    height={336}
                />;
            default:
                return <Typography color={"red"} align="center" >Not implemented</Typography>;
        }
    }

    return (
        <Box className={classes.root}>
            <Typography>Graph test Page</Typography><br />
            <ToggleButtonGroup exclusive value={graph} onChange={(e, value) => setGraph(value)} >
                <ToggleButton value="1" >Rate graph</ToggleButton>
                <ToggleButton value="2">Saving graph</ToggleButton>
                <ToggleButton value="3">Usage graph</ToggleButton>
            </ToggleButtonGroup>
            <br />
            <br />
            <br />
            <ShowGraph />
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 20,
        width: "100%",
        height: "100%"
    }
}))